module.exports = __webpack_public_path__ + "static/media/dai.258670d3.svg";